/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */
import type { OrganizationResponse } from './organizationResponse';
import type { OrgComplianceSettingsResponse } from './orgComplianceSettingsResponse';
import type { UserResponse } from './userResponse';

export interface MeResponse {
  user: UserResponse;
  organization?: OrganizationResponse | null;
  selected_project_id?: string | null;
  compliance_settings?: OrgComplianceSettingsResponse | null;
}
